<template>
    <v-container>
        <ws-page
        v-bind="treats"
        />
      <br>
      <br>
        <v-footer
          id="program-footer"
          color="primary"
          dark
          min-height="72"
          class="hidden-md-and-up"
        >
          <v-container>
            <v-row>
              <v-col
                cols="12"
                md="6"
              >
                <div class="d-flex flex-wrap justify-md-start justify-center justify-md-none">
                  <template v-for="(s, i) in workshopsfooter">
                    <router-link
                      :key="s.name"
                      class="white--text pa-1 pa-md-0"
                      :to="s.url"
                      v-text="s.name"
                    />

                    <v-responsive
                      v-if="i < workshopsfooter.length - 1"
                      :key="`divider-${s.name}`"
                      class="mx-4 shrink hidden-sm-and-down"
                      max-height="24"
                    >
                      <v-divider vertical />
                    </v-responsive>
                  </template>
                </div>
              </v-col>
            </v-row>
          </v-container>
        </v-footer>
      </v-container>
</template>

<script>
  import WsPage from '../../components/base/WsPage.vue'
  export default {
  components: { WsPage },
    name: 'AiTreats',

    data: () => ({
      isMobile: false,
      workshopsfooter: [
        {
          name: 'Fringe Workshops',
          url: 'fringe-workshops',
        },
        {
          name: 'AI-Treats',
          url: 'ai-treats',
        },
        {
          name: 'eARTS',
          url: 'e-arts',
        },
        {
          name: 'IMTR',
          url: 'imtr',
        },
      ],
      treats: {
        title: 'Workshop on AI Hardware: Test, Reliability and Security (AI-TREATS)',
        website: 'https://ai-treats-workshop.aalto.fi/',
        abstract: 'Recent advances in Artificial Intelligence (AI), in particular deep learning, have led to numerous applications, including computer vision, speech recognition, natural language processing, robotics, etc. Autonomous vehicles are also afoot and AI will be the core enabling technology. In parallel, there is intense activity in designing dedicated hardware for AI. On one hand, AI hardware accelerators are demanded to support the tremendous processing power, unprecedented speed, and memory costs that deep neural networks require so as to realize their full potential. On the other hand, there is a large incentive for moving the AI algorithms execution from the cloud into the edge devices, i.e. Internet-of-Things (IoT) devices, in particular for meeting data confidentiality and network bandwidth requirements and eliminating the communication latency. Edge devices are expected to include local 3ETS FRINGE WORKSHOP PR | v.0.9AI processing, yet this is challenging as an edge device is a resource-constrained environment. AI hardware design efforts rapidly evolve exploring various architectures (e.g., machine learning-based, spiking), design flavors (e.g., digital, mixed analog-digital), and emerging technologies (e.g., memristive devices arranged into crossbars to implement efficiently the multiply-add matrix operations in neural networks). The aim of this Workshop is to focus particularly on the following emerging problems pertaining to AI hardware:Testing: fault modelling, fault simulation, test generation, post-manufacturing testing, design-for-test, built-in self-test, on-line testing, fault diagnosis.Reliability: reliability analysis, design-for-reliability, fault-tolerance, self-repair, functional safety.Hardware security and trust: IP/IC piracy, hardware Trojans, side-channel attacks, fault injection attacks.',
        chairs: '<strong> Organizers:</strong> Haralampos-G. Stratigopoulos (Sorbonne University, CNRS, LIP6, France), Ioana Vatajelu (Grenoble Alpes University, CNRS, Grenoble INP, TIMA, France), Fei Su (Intel, USA), Martin Andraud (Aalto University, Finland)',
        dates: [
          {
          name: 'Workshop Papers submission deadline',
          date: '<s>6 March 2023</s> <strong>20 March 2023</strong> <span style="color: red;">(Extended Deadline)</span>',
          },
          {
            name: 'Authors notification',
            date: '1 April 2023',
          },
        ],
        image: require('@/assets/aitreatspng.png'),
      },
    }),
    mounted() {

    },
    methods: {
      isMobileDevice () {
        return (typeof window.orientation !== 'undefined') || (navigator.userAgent.indexOf('IEMobile') !== -1)
      },
    },
  }
</script>
